import * as STUDENTACTIONS from '../../actions/student.action'

const initialState = {
    data: [],
    loading: false,
    success: false,
    failure: false,
}

export default function returnstate(state = initialState, action) {

    switch (action.type) {
        case STUDENTACTIONS.GET_STUDENTID.REQUEST:
            return {
                ...state,
                loading: true,
                success: false,
                failure: false,
            };
        case STUDENTACTIONS.GET_STUDENTID.SUCCESS:     
        return {
                ...state,
                data: action.payload,
                loading: false,
                success: true,
                failure: false
            };

        case STUDENTACTIONS.GET_STUDENTID.FAILURE:
            return {
                ...state,
                data: [],
                loading: false,
                success: false,
                failure: true,
            };
        default: return state
    }
}